export default {
  en: {
    /* ----- Common ----- */
    retry: "Retry",
    search: "Search",
    save: "Save",
    edit: "Edit",
    default: "Default",
    setAll: "Set all",
    yes: "Yes",
    no: "No",
    low: "Low",
    medium: "Medium",
    high: "High",
    to: "to",
    auto: "Auto",
    reports: "Reports",
    attachment: "Attachment",
    configureHeaders: "Configure Headers",
    noSearchResults: "No search results found",
    formNoChanges: "Form has no changes",
    noMatchingSearchResults: "No matching search results found.",
    tryAgainWithFilters:
      "Please try again by changing the filters or clear it to get all the data.",
    clearAll: "Clear All",
    noDataAvailable: "No data available",
    noEmployeesMatchSearch: "No employees match your search",
    inviteTeamMembers:
      "Please invite your team members to track their activities.",
    technicalIssue:
      "Sorry, This issue seems to be from our side. Would you mind trying it after some time or talk to your administrator ?",
    somethingWentWrongFetching:
      "Something went wrong while fetching the {message}. If you continue to see this problem please talk to your platform administrator.",
    somethingWentWrongUpdating:
      "Something went wrong while updating the {message}. If you continue to see this problem please talk to your platform administrator.",
    technicalDifficultiesFetching:
      "It's us! There seems to be some technical difficulties while fetching the {message}. Please try after some time.",
    technicalDifficultiesUpdating:
      "It's us! There seems to be some technical difficulties while updating the {message}. Please try after some time.",
    noAccessUpdate:
      "Sorry, you don't have rights to update the {message}. Please contact system administrator.",
    productivityMonitoringSettings: "productivity monitoring settings",
    productivityMonitoringBlurSettings: "productivity monitoring blur settings",
    screenshotBlurSettings: "screenshot blur settings",
    dlpSettings: "DLP settings",
    appsAndURLsSettings: "apps and URLs settings",
    teamActivityGoalSettings: "team activity goal settings",
    idleTimeSettings: "idle time settings",
    orgSettingsUpdatedEmployeeError:
      "Organization level settings are updated successfully but unable to update employee level settings.",
    settingsUpdatedSuccess: "Settings updated successfully",
    employeeId: "Employee Id",
    employeeName: "Employee Name",
    team: "Team:",
    accessDeniedMsg: "Sorry, you don't have rights to update {message}.",
    noChanges: "No changes",

    /* ----- Data Loss Prevention ----- */
    dataLossPrevention: "Data Loss Prevention",
    internetAccessControl: "Internet access control",
    locationTracking: "Location tracking",
    keyLogging: "Key logging",
    additionalScreenshots: "Additional screenshots",
    auditLog: "Audit Log",
    somethingWentWrongLoadingDLP: "{somethingWentWrong}",

    /* ----- ScreenshotFrequency ----- */
    screenshotFrequency: "Screenshot Frequency",
    configureScreenshotFrequency:
      "Configure the number of screenshots to be taken at every 10 minutes frequency for each employee or across the organization.",
    duration: "Duration",
    everyMinutes: "Every {minutes}:00 minutes",
    captureScreenshot: "Capture Screenshot",
    numberOfScreenshots: "Number Of Screenshots",
    one: "One",
    two: "Two",
    three: "Three",
    setAllScreenshots: "Set all",
    emailAddress: "Email Address",
    screenshotAccessDeniedMsg:
      "Sorry, you don't have rights to update productivity monitoring settings. Please contact system administrator.",
    screenshotSettingsUpdatedSuccess:
      "Productivity monitoring screenshot frequency settings updated successfully.",
    screenshotTechnicalDifficultiesFetching: "{technicalDifficulties}",
    screenshotSomethingWentWrongFetching: "{somethingWentWrong}",
    screenshotSomethingWentWrongUpdating: "{somethingWentWrong}",
    screenshotNoAccessUpdate:
      "Sorry, you don't have rights to update screenshot frequency settings. Please contact system administrator.",

    /* ----- FileTransfers ----- */
    fileTransfers: "File Transfers",
    configureTrackOperations:
      "Configure what to track and the operations to be monitored for each employee or at the organization level",
    setAllDLP: "Set all",
    dlpSettingsUpdatedSuccess: "DLP settings updated successfully.",
    dlpTechnicalDifficulties: "{technicalDifficulties}",
    dlpNoAccessUpdate:
      "Sorry, you don't have rights to update DLP settings. Please contact HR administrator.",
    dlpSomethingWentWrongFetching: "{somethingWentWrong}",
    dlpSomethingWentWrongUpdating: "{somethingWentWrong}",

    /* ----- FileTransfersEditModal ----- */
    fileTransfersDLP: "File Transfers (Data Loss Prevention)",
    whatToTrack: "What to Track?",
    localFiles: "Local Files",
    networkFiles: "Network Files",
    externalDrives: "External Drives",
    fileSyncWithCloudServices: "File Sync with Cloud Services",
    operationsToMonitor: "Operations to Monitor",
    noFileTrackingMessage:
      "In the absence of file tracking, no file options can be enabled",
    access: "Access",
    copy: "Copy",
    create: "Create",
    delete: "Delete",
    download: "Download",
    rename: "Rename",
    upload: "Upload",
    write: "Write",

    /* ----- TeamActivityGoal ----- */
    teamActivityGoal: "Team Activity Goal",
    activityGoals: "Activity Goals",
    activityGoalDescription:
      "The activity goal slabs are configured to users based on their role to differentiate their productivity levels.",
    employeesSelected: "({count}) Employee(s) Selected",
    activityGoal: "Activity Goal",

    /* ----- ScreenshotBlur ----- */
    screenshotBlur: "Screenshot Blur",
    screenshotBlurDescription:
      "Controls the desktop application to blur the activity screenshots for security and privacy reasons, either at the employee level or across the organization.",
    noEmpData: "No Employee Data",

    /* ----- ScheduleAndEffort ----- */
    scheduleAndEffort: "Schedule and Effort",
    scheduleAndEffortDescription:
      "Activity Tracker summarize all effort into days, weeks and months based on the time zone of the Organization. This aggregated data is then used for reports and other insights.",
    workSchedule: "Work Schedule",
    timezone: "Timezone",
    targetEffortPerWeekInHours: "Target Effort Per Week",
    totalEffortPerWeek: "Total Effort Per Week",
    addWorkSchedule: "Add Work Schedule",
    noTimezoneExist: "No timezone exist.",
    addTimezone: "Add Timezone",
    timeZone: "Time Zone",
    trackWeekEndData: "Track Weekend Date",
    trackWeekEndDataTooltip:
      "Determines whether data is tracked for weekend dates. Data is recorded based on the setting active at the time of tracking.",
    targetEffortPerWeek: "Target Effort Per Week",
    scheduleAndEffortSettingsUpdated:
      "Schedule and effort settings updated successfully",
    technicalIssueScheduleEffort: "{technicalDifficulties}",
    noAccessUpdateScheduleEffort:
      "Sorry, you don't have rights to update schedule and effort settings. Please contact system administrator.",
    errorUpdatingOrgWorkSchedule: "{somethingWentWrong}",
    errorUpdatingEmpWorkSchedule: "{somethingWentWrong}",
    errorUpdatingWorkSchedule: "{somethingWentWrong}",
    errorFetchingScheduleEffort: "{somethingWentWrong}",

    /* ----- IdleTime ----- */
    idleTimeout: "Idle Timeout",
    idleTimeoutInMinutes: "Idle Timeout (In Minutes)",
    idleTimeoutDescription: "Control how the desktop app detects idle time.",
    considerIdleNotActiveTime: "Consider Idle/Not Active Time",
    considerIdleNotActiveTimeDescription:
      "Based on the settings below, the system will consider the idle/not active time for productivity % calculation for individuals",
    never: "Never",
    tenMinutes: "10 Minutes",
    twentyMinutes: "20 Minutes",
    thirtyMinutes: "30 Minutes",
    always: "Always",
    fixedHours: "Fixed Hours",
    hours: "Hours",
    minutes: "Minutes",
    inMinutes: "in minutes",

    /* ----- Performance Management ----- */
    skills: "Skills",
    goals: "Goals",
    enable: "Enable",
    disable: "Disable",
    emailReminder: "Email Reminder",
    performanceManagementSystemBasedOn:
      "Performance management system based on",
    presentTeamMembersToReportingManagersOnly:
      "Present team members to reporting managers only",
    ratingAssessmentReminderNotificationDate:
      "Rating assessment reminder notification date",
    goalsAssignmentReminderNotificationDate:
      "Goals assignment reminder notification date",
    firstReminder: "1st Reminder",
    secondReminder: "2nd Reminder",
    day: "Day",
    ofEveryMonth: "of every month",
    secondReminderDateShouldNotBeSameAsFirst:
      "2nd reminder date should not be the same as 1st reminder.",
    pmsSettingsUpdatedSuccessfully: "PMS settings updated successfully",
    somethingWentWrongUpdatingPmsSettings:
      "Something went wrong while updating the PMS settings. Please try after some time.",
    somethingWentWrongUpdatingPmsSettingsContactAdmin:
      "Something went wrong while updating the PMS settings. If you continue to see this issue, please contact the platform administrator.",
    noAccessUpdatePerformanceManagementSettings:
      "Sorry, you don't have access to update performance management settings. Please contact your administrator.",

    idleTimeSettingsUpdated:
      "Productivity monitoring idle time settings updated successfully",
    idleTimeTechnicalDifficulties: "{technicalDifficulties}",
    idleTimeSomethingWentWrongFetching: "{somethingWentWrong}",
    idleTimeNoAccessUpdate:
      "Sorry, you don't have rights to update idle time settings. Please contact system administrator.",
    idleTimeOrgSettingsUpdatedEmployeeError:
      "{orgSettingsUpdatedEmployeeError}",
    idleTimeErrorUpdatingOrgSettings: "{somethingWentWrong}",
    idleTimeErrorUpdatingEmpSettings: "{somethingWentWrong}",
    idleTimeErrorUpdatingSettings: "{somethingWentWrong}",
    fixedHoursMinimum: "Fixed hours must be at least 1 hour",
    fixedHoursInvalidEmployee:
      "Correct the invalid employee fixed hours before saving",
    idleTimeMixedSettingsNote:
      "Having mixed idle time settings for employees will have inconsistency in productivity data representation in reports and insights. Please be sure of this impact before you configure the idle time settings at the employee level.",

    /* ----- EmployeeMonitoring ----- */
    productivityMonitoring: "Productivity Monitoring",
    appsAndUrls: "Apps and URLs",
    off: "Off",
    idleTime: "Idle Time",
    dailyInsightsNotification: "Daily Insights Notification",
    somethingWentWrongLoadingSettings:
      "Something went wrong while loading the productivity monitoring settings. Please try after some time.",

    /* ----- DailyInsightsNotification ----- */
    dailyInsightsNotificationDescription:
      "Configure to share daily insights to individuals based on their productivity",
    adminNotification: "Admin Notification",
    adminNotificationDescription:
      "Configure to share daily insights to admins based on organization productivity",
    managerNotification: "Manager Notification",
    managerNotificationDescription:
      "Configure to share daily insights to managers based on team's productivity",
    inviteTeamMembersInsights:
      "Please invite your team members to configure insights notification.",
    key: "Key",
    accessDeniedMsgInsights:
      "Sorry, you don't have rights to update. Please contact HR administrator.",

    /* ----- AppUrlCategoryModel ----- */
    apps: "Apps",
    urls: "URLs",
    category: "Category",
    customGroup: "Custom Group",
    customAlert: "Custom Alert",
    toxicityIdentifier: "Toxicity Identifier",
    selectCustomGroup: "Select Custom Group",
    copyClassificationFrom: "Copy Classification From",
    copyNow: "Copy Now",
    all: "All",
    productive: "Productive",
    unproductive: "Unproductive",
    uncategorized: "Uncategorized",
    applicationName: "Application Name",
    wildcardConfiguration: "Wildcard Configuration",
    export: "Export",
    back: "Back",
    domainName: "Domain Name",
    addMore: "Add More",
    classificationsCopiedSuccess: "Classifications Copied Successfully!",
    appsCategoryListUpdated: "Apps category list updated successfully.",
    urlsCategoryListUpdated: "URLs category list updated successfully.",
    noAccessUpdateSettings:
      "Sorry, you don't have rights to update the productivity monitoring settings. Please contact your administrator.",
    domainWhitelistingUpdated: "Domain whitelisting {action} successfully.",
    noAccessUpdateDomainWhitelisting:
      "Sorry, you don't have rights to update the domain whitelisting settings. Please contact your administrator.",
    domainAlreadyExists:
      "Unable to add/update the domain as it was already exist",
    technicalDifficultiesDomainWhitelisting:
      "It's us! There seems to be some technical difficulties. Please try after some time.",
    somethingWentWrongDomainWhitelisting:
      "Something went wrong while domain whitelisting settings. Please try after some time.",
    somethingWentWrongValidatingDomainWhitelisting:
      "Something went wrong while validating the inputs when updating the domain whitelisting settings. Please try after some time.",
    somethingWentWrongUpdatingDomainWhitelisting:
      "Something went wrong while updating the domain whitelisting settings. If you continue to see this problem contact the platform administrator.",

    /* ----- AppUrlCategoryCard ----- */
    noAppsToCategorize: "You do not have any Apps to categorize.",
    noUrlsToCategorize: "You do not have any URLs to categorize.",

    /* ----- AppsAndUrlsTracker ----- */
    appsAndUrlsTracker: "Apps and URLs Tracker",
    appsAndUrlsTrackerDescription:
      "Controls the apps and websites monitoring for organization",
    defaultCategory: "Default Category",
    classificationForGroup: "Classification for the Group",
    unableToFetchCustomGroup:
      "Unable to fetch Custom Employee Group. Please refresh and try again.",
    classifyAppsAndUrlsForTeams: "You can classify apps and URLs for teams",
    createGroup: "Create Group",
    group: "Group",
    trackAppsAndUrls: "Track Apps and URLs",
    inviteTeamMembersToTrackActivities:
      "Please invite your team members to track their activities.",
    appsAndUrlsSettingsUpdated:
      "Productivity monitoring apps and URLs settings updated successfully",

    /* ----- Admin and Member Management ----- */
    adminManagerInvitees: "Admin/Manager Invitees",
    adminsManagersOnboardedSuccessfully:
      "Admins/Managers onboarded successfully",
    importTeamMembersErrorMessage:
      "Error while processing the request to importing the team members",
    confirmDeleteInvite: "Are you sure you want to delete this invitation?",
    emailAddressAlreadyExists: "Email address already exists",
    emailAddressUpdatedSuccessfully: "Email address updated successfully",
    invitedMemberDeletedSuccessfully: "Invited member deleted successfully",
    onboard: "Onboard",
    onboardNewAdminMember: "Onboard New Admin/Member",

    /* ----- Access Rights Messages ----- */
    noAccessRightsToSendNotificationToOfflineEmployees:
      "Sorry, you don't have access rights to send notifications to offline employees. Please contact your administrator.",
    noAccessRightsToViewActivitySummaries:
      "Sorry, you don't have access rights to view activity summaries. Please contact your administrator.",
    noAccessRightsToViewTeamActivityDetails:
      "Sorry, you don't have access rights to view team activity details. Please contact your administrator.",
    noAccessToDeleteInvitedMembers:
      "Sorry, you don't have access to delete invited members. Please contact your administrator.",
    noAccessToInviteAdminsManagers:
      "Sorry, you don't have access to invite admins/managers. Please contact your administrator.",
    noAccessToResendInvitations:
      "Sorry, you don't have access to resend invitations. Please contact your administrator.",
    noAccessToUpdateEmailAddress:
      "Sorry, you don't have access to update email addresses. Please contact your administrator.",
    noAccessToViewAdminsManagers:
      "Sorry, you don't have access to view admins/managers. Please contact your administrator.",
    noAccessToViewInvitedAdmins:
      "Sorry, you don't have access to view invited admins. Please contact your administrator.",
    noAccessToViewTeamMembersList:
      "Sorry, you don't have access to view team members list. Please contact your administrator.",
    noAccessUpdateDLP:
      "Sorry, you don't have access to update DLP settings. Please contact your administrator.",

    /* ----- Error Messages ----- */
    somethingWentWrongFetchingDLP:
      "Something went wrong while fetching DLP settings. Please try after some time.",
    somethingWentWrongUpdatingDLP:
      "Something went wrong while updating DLP settings. Please try after some time.",
    somethingWentWrongWhileFetchingAdminsManagers:
      "Something went wrong while fetching admins/managers. Please try after some time.",
    somethingWentWrongWhileFetchingInvitedAdmins:
      "Something went wrong while fetching invited admins. Please try after some time.",
    somethingWentWrongWhileFetchingTeamActivityDetails:
      "Something went wrong while fetching team activity details. Please try after some time.",
    somethingWentWrongWhileFetchingTeamActivityDetailsContactAdmin:
      "Something went wrong while fetching team activity details. If you continue to see this issue, please contact the platform administrator.",
    somethingWentWrongWhileFetchingTeamMembers:
      "Something went wrong while fetching team members. Please try after some time.",
    somethingWentWrongWhileInvitingAdminsManagers:
      "Something went wrong while inviting admins/managers. Please try after some time.",
    somethingWentWrongWhileNotifyingOfflineEmployees:
      "Something went wrong while notifying offline employees. Please try after some time.",
    somethingWentWrongWhileNotifyingOfflineEmployeesContactAdmin:
      "Something went wrong while notifying offline employees. If you continue to see this issue, please contact the platform administrator.",
    somethingWentWrongWhileResendingInvitation:
      "Something went wrong while resending invitation. Please try after some time.",
    somethingWentWrongWhileUpdatingEmailAddress:
      "Something went wrong while updating email address. Please try after some time.",

    /* ----- Notifications and Success Messages ----- */
    notificationSentSuccessfullyToOfflineEmployees:
      "Notification sent successfully to offline employees",

    /* ----- Work Schedule ----- */
    addWorkScheduleNoUpdateAccess:
      "Sorry, you don't have access to add work schedules. Please contact your administrator.",

    /* ----- Reports ----- */
    customReportHeaders: "Custom Report Headers",
    dailyInsightsNotificationReports: "Daily Insights Notification Reports",
    dataIntegration: "Data Integration",
    headerFooterTemplates: "Header Footer Templates",
    headerTemplate: "Header Template",
    footerTemplate: "Footer Template",
    selectTemplate: "Select Template",
    notConfigured: "Not configured",
    successHeaderFooterUpdate: "Header/Footer template updated successfully",
    errorUpdatingHeaderFooter:
      "Something went wrong while updating the template. Please try again.",
    timeActivityReport: "Time Activity Report",
    timeActivityReportContent: "Shows the time spent on different activities",
    attendanceReport: "Attendance Report",
    attendanceReportContent: "Shows attendance details",
    appsReport: "Apps Report",
    appsReportContent: "Shows app usage details",
    appsTitleReport: "Apps Title Report",
    appsTitleReportContent: "Shows app title details",
    urlsReport: "URLs Report",
    urlsReportContent: "Shows URL usage details",
    productiveAppsReport: "Productive Apps Report",
    productiveAppsReportContent: "Shows productive app usage details",
    productiveUrlsReport: "Productive URLs Report",
    productiveUrlsReportContent: "Shows productive URL usage details",
    consolidatedAppsUrlsReport: "Consolidated Apps & URLs Report",
    consolidatedAppsUrlsReportContent:
      "Shows consolidated app and URL usage details",
    efficiencyReport: "Efficiency Report",
    efficiencyReportContent: "Shows efficiency metrics",
    lowActivityReport: "Low Activity Report",
    lowActivityReportContent: "Shows low activity periods",
    productivitySummaryReport: "Productivity Summary Report",
    productivitySummaryReportContent: "Shows productivity summary",
    productiveUnproductiveSummaryReport:
      "Productive/Unproductive Summary Report",
    productiveUnproductiveSummaryReportContent:
      "Shows productive and unproductive activity summary",
    productiveAppsMetric: "Productive Apps Metric",
    productiveAppsMetricContent: "Shows productive apps metrics",
    productiveUrlsMetric: "Productive URLs Metric",
    productiveUrlsMetricContent: "Shows productive URLs metrics",
    unproductiveAppsMetrics: "Unproductive Apps Metrics",
    unproductiveAppsMetricsContent: "Shows unproductive apps metrics",
    unproductiveUrlsMetric: "Unproductive URLs Metric",
    unproductiveUrlsMetricContent: "Shows unproductive URLs metrics",
    monthlySummaryReport: "Monthly Summary Report",
    monthlySummaryReportContent: "Shows monthly activity summary",
    weeklySummaryReport: "Weekly Summary Report",
    weeklySummaryReportContent: "Shows weekly activity summary",
    fileAndWebFileEventSummaryReport: "File & Web File Event Summary Report",
    fileAndWebFileEventSummaryReportContent:
      "Shows file and web file event summary",
    fileEventReport: "File Event Report",
    fileEventReportContent: "Shows file event details",
    webFileEventReport: "Web File Event Report",
    webFileEventReportContent: "Shows web file event details",
    locationIntelligenceReport: "Location Intelligence Report",
    locationIntelligenceReportContent:
      "Shows user activity based on their location",
    locationIntelligenceMonthlySummaryReport:
      "Location Intelligence Monthly Summary Report",
    locationIntelligenceMonthlySummaryReportContent:
      "Generate a report for user activity based on their location",
    assetReport: "Asset Report",
    assetReportContent: "Shows asset details",
    errorTechnicalDifficulties: "{technicalDifficulties}",
    errorProcessingReportHeaders: "{somethingWentWrong}",
    errorNoReportHeadersConfig:
      "The custom configuration data does not exist. Please contact the system administrator.",
    errorRetrievingReports: "{somethingWentWrong}",
    errorRetrievingReportsGeneric: "{somethingWentWrong}",
    errorTechnicalIssue: "{technicalDifficulties}",
    errorNoUpdateRights:
      "Sorry, you don't have rights to update the report headers. Please contact HR administrator.",
    errorUpdatingInsightsSettings: "{somethingWentWrong}",
    errorUpdatingInsightsSettingsGeneric: "{somethingWentWrong}",
    errorNoDefaultHeaders: "No default headers found for this report.",
    successInsightsNotificationUpdate:
      "Insights notification settings updated successfully",
    successReportHeadersUpdate: "Report headers settings updated successfully",
    errorNoFormChanges: "{formNoChanges}",
    errorTechnicalDifficultiesHeaders: "{technicalDifficulties}",
    errorNoHeaderUpdateRights:
      "Sorry, you don't have rights to update the report headers. Please contact HR administrator.",
    errorUpdatingReportHeaders: "{somethingWentWrong}",
    errorUpdatingReportHeadersGeneric: "{somethingWentWrong}",

    /* ----- Error Messages ----- */
    somethingWentWrong:
      "Something went wrong. If you continue to see this problem please talk to your platform administrator.",
    noAccessRights:
      "Sorry, you don't have rights to {action}. Please contact {admin} administrator.",
    settingsUpdated: "{setting} settings updated successfully",
    unableToFetch: "Unable to fetch {item}. Please refresh and try again.",
  },
  sp: {
    /* ----- Common ----- */
    retry: "Reintentar",
    search: "Buscar",
    save: "Guardar",
    edit: "Editar",
    default: "Predeterminado",
    setAll: "Establecer todo",
    yes: "Sí",
    no: "No",
    low: "Bajo",
    medium: "Medio",
    high: "Alto",
    to: "a",
    auto: "Auto",
    reports: "Informes",
    attachment: "Adjunto",
    configureHeaders: "Configurar Encabezados",
    noSearchResults: "No se encontraron resultados de búsqueda",
    formNoChanges: "El formulario no tiene cambios",
    noMatchingSearchResults:
      "No se encontraron resultados de búsqueda coincidentes.",
    tryAgainWithFilters:
      "Por favor, intente nuevamente cambiando los filtros o límpielos para obtener todos los datos.",
    clearAll: "Limpiar Todo",
    noDataAvailable: "No hay datos disponibles",
    noEmployeesMatchSearch: "Ningún empleado coincide con su búsqueda",
    inviteTeamMembers:
      "Por favor, invite a los miembros de su equipo para rastrear sus actividades.",
    technicalIssue:
      "Lo sentimos, este problema parece ser de nuestra parte. ¿Le importaría intentarlo después de un tiempo o hablar con su administrador?",
    somethingWentWrongFetching:
      "Algo salió mal al obtener {message}. Si continúa viendo este problema, hable con su administrador de plataforma.",
    somethingWentWrongUpdating:
      "Algo salió mal al actualizar {message}. Si continúa viendo este problema, hable con su administrador de plataforma.",
    technicalDifficultiesFetching:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al obtener {message}. Por favor, inténtelo después de un tiempo.",
    technicalDifficultiesUpdating:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas al actualizar {message}. Por favor, inténtelo después de un tiempo.",
    noAccessUpdate:
      "Lo sentimos, no tiene derechos para actualizar {message}. Por favor, contacte al administrador del sistema.",
    productivityMonitoringSettings:
      "la configuración de monitoreo de productividad",
    productivityMonitoringBlurSettings:
      "configuración de desenfoque de monitoreo de productividad",
    screenshotBlurSettings:
      "configuración de desenfoque de captura de pantalla",
    dlpSettings: "configuración de DLP",
    appsAndURLsSettings: "configuración de aplicaciones y URLs",
    teamActivityGoalSettings:
      "configuración de objetivo de actividad del equipo",
    idleTimeSettings: "configuración de tiempo inactivo",
    orgSettingsUpdatedEmployeeError:
      "La configuración a nivel de organización se actualizó con éxito, pero no se pudo actualizar la configuración a nivel de empleado.",
    settingsUpdatedSuccess: "Configuración actualizada con éxito",
    employeeId: "ID de Empleado",
    employeeName: "Nombre del Empleado",
    team: "Equipo:",
    accessDeniedMsg:
      "Lo sentimos, no tiene derechos para actualizar {message}.",
    noChanges: "Sin cambios",

    /* ----- Data Loss Prevention ----- */
    dataLossPrevention: "Prevención de Pérdida de Datos",
    internetAccessControl: "Control de acceso a Internet",
    locationTracking: "Seguimiento de Ubicación",
    keyLogging: "Registro de Teclas",
    additionalScreenshots: "Capturas de Pantalla Adicionales",
    auditLog: "Registro de Auditoría",
    somethingWentWrongLoadingDLP: "{somethingWentWrong}",

    /* ----- ScreenshotFrequency ----- */
    screenshotFrequency: "Frecuencia de Capturas de Pantalla",
    configureScreenshotFrequency:
      "Configure el número de capturas de pantalla que se tomarán cada 10 minutos para cada empleado o en toda la organización.",
    duration: "Duración",
    everyMinutes: "Cada {minutes}:00 minutos",
    captureScreenshot: "Capturar Pantalla",
    numberOfScreenshots: "Número de Capturas de Pantalla",
    one: "Uno",
    two: "Dos",
    three: "Tres",
    setAllScreenshots: "Establecer todo",
    emailAddress: "Dirección de Correo Electrónico",
    screenshotAccessDeniedMsg:
      "Lo sentimos, no tiene derechos para actualizar la configuración de monitoreo de productividad. Por favor, contacte al administrador del sistema.",
    screenshotSettingsUpdatedSuccess:
      "Configuración de la frecuencia de capturas de pantalla actualizada con éxito.",
    screenshotTechnicalDifficultiesFetching: "{technicalDifficulties}",
    screenshotSomethingWentWrongFetching: "{somethingWentWrong}",
    screenshotSomethingWentWrongUpdating: "{somethingWentWrong}",
    screenshotNoAccessUpdate:
      "Lo sentimos, no tiene derechos para actualizar la configuración de frecuencia de capturas de pantalla. Por favor, contacte al administrador del sistema.",

    /* ----- FileTransfers ----- */
    fileTransfers: "Transferencias de Archivos",
    configureTrackOperations:
      "Configure qué rastrear y las operaciones a monitorear para cada empleado o a nivel de organización",
    setAllDLP: "Establecer todo",
    dlpSettingsUpdatedSuccess: "Configuración de DLP actualizada con éxito.",
    dlpTechnicalDifficulties: "{technicalDifficulties}",
    dlpNoAccessUpdate:
      "Lo sentimos, no tiene derechos para actualizar la configuración de DLP. Por favor, contacte al administrador de RRHH.",
    dlpSomethingWentWrongFetching: "{somethingWentWrong}",
    dlpSomethingWentWrongUpdating: "{somethingWentWrong}",

    /* ----- FileTransfersEditModal ----- */
    fileTransfersDLP:
      "Transferencias de Archivos (Prevención de Pérdida de Datos)",
    whatToTrack: "¿Qué Rastrear?",
    localFiles: "Archivos Locales",
    networkFiles: "Archivos de Red",
    externalDrives: "Unidades Externas",
    fileSyncWithCloudServices:
      "Sincronización de Archivos con Servicios en la Nube",
    operationsToMonitor: "Operaciones a Monitorear",
    noFileTrackingMessage:
      "En ausencia de seguimiento de archivos, no se pueden habilitar opciones de archivo",
    access: "Acceso",
    copy: "Copiar",
    create: "Crear",
    delete: "Eliminar",
    download: "Descargar",
    rename: "Renombrar",
    upload: "Subir",
    write: "Escribir",

    /* ----- TeamActivityGoal ----- */
    teamActivityGoal: "Objetivo de Actividad del Equipo",
    activityGoals: "Objetivos de Actividad",
    activityGoalDescription:
      "Los niveles de objetivo de actividad están configurados para los usuarios según su rol para diferenciar sus niveles de productividad.",
    employeesSelected: "({count}) Empleado(s) Seleccionado(s)",
    activityGoal: "Objetivo de Actividad",

    /* ----- ScreenshotBlur ----- */
    screenshotBlur: "Desenfoque de Captura de Pantalla",
    screenshotBlurDescription:
      "Controla la aplicación de escritorio para desenfocar las capturas de pantalla de actividad por razones de seguridad y privacidad, ya sea a nivel de empleado o en toda la organización.",
    noEmpData: "Sin Datos de Empleado",

    /* ----- ScheduleAndEffort ----- */
    scheduleAndEffort: "Horario y Esfuerzo",
    scheduleAndEffortDescription:
      "El Rastreador de Actividad resume todo el esfuerzo en días, semanas y meses según la zona horaria de la Organización. Estos datos agregados se utilizan luego para informes y otros análisis.",
    workSchedule: "Horario de Trabajo",
    timezone: "Zona Horaria",
    targetEffortPerWeekInHours: "Esfuerzo Objetivo por Semana",
    totalEffortPerWeek: "Esfuerzo Total por Semana",
    addWorkSchedule: "Agregar Horario de Trabajo",
    noTimezoneExist: "No existe zona horaria.",
    addTimezone: "Agregar Zona Horaria",
    timeZone: "Zona Horaria",
    trackWeekEndData: "Seguimiento de fechas de fin de semana",
    trackWeekEndDataTooltip:
      "Determina si los datos se registran para las fechas de fin de semana. Los datos se registran según la configuración activa en el momento del seguimiento.",
    targetEffortPerWeek: "Esfuerzo Objetivo por Semana",
    scheduleAndEffortSettingsUpdated:
      "Configuración de horario y esfuerzo actualizada con éxito.",
    technicalIssueScheduleEffort: "{technicalDifficulties}",
    noAccessUpdateScheduleEffort:
      "Lo sentimos, no tiene derechos para actualizar la configuración de horario y esfuerzo. Por favor, contacte al administrador del sistema.",
    errorUpdatingOrgWorkSchedule: "{somethingWentWrong}",
    errorUpdatingEmpWorkSchedule: "{somethingWentWrong}",
    errorUpdatingWorkSchedule: "{somethingWentWrong}",
    errorFetchingScheduleEffort: "{somethingWentWrong}",

    /* ----- IdleTime ----- */
    idleTimeout: "Tiempo de Inactividad",
    idleTimeoutInMinutes: "Tiempo de Inactividad (En Minutos)",
    idleTimeoutDescription:
      "Controla cómo la aplicación de escritorio detecta el tiempo de inactividad.",
    considerIdleNotActiveTime: "Considerar Tiempo Inactivo/No Activo",
    considerIdleNotActiveTimeDescription:
      "Según la configuración a continuación, el sistema considerará el tiempo inactivo/no activo para el cálculo del porcentaje de productividad para individuos",
    never: "Nunca",
    tenMinutes: "10 Minutos",
    twentyMinutes: "20 Minutos",
    thirtyMinutes: "30 Minutos",
    always: "Siempre",
    fixedHours: "Horas Fijas",
    hours: "Horas",
    minutes: "Minutos",
    inMinutes: "en minutos",

    /* ----- Performance Management ----- */
    skills: "Habilidades",
    goals: "Objetivos",
    enable: "Habilitar",
    disable: "Deshabilitar",
    emailReminder: "Recordatorio por Correo",
    performanceManagementSystemBasedOn:
      "Sistema de gestión del rendimiento basado en",
    presentTeamMembersToReportingManagersOnly:
      "Presentar miembros del equipo solo a los gerentes de informes",
    ratingAssessmentReminderNotificationDate:
      "Fecha de notificación de recordatorio de evaluación de calificación",
    goalsAssignmentReminderNotificationDate:
      "Fecha de notificación de recordatorio de asignación de objetivos",
    firstReminder: "1er Recordatorio",
    secondReminder: "2do Recordatorio",
    day: "Día",
    ofEveryMonth: "de cada mes",
    secondReminderDateShouldNotBeSameAsFirst:
      "La fecha del 2do recordatorio no debe ser la misma que la del 1er recordatorio.",
    pmsSettingsUpdatedSuccessfully:
      "Configuraciones de PMS actualizadas exitosamente",
    somethingWentWrongUpdatingPmsSettings:
      "Algo salió mal al actualizar las configuraciones de PMS. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongUpdatingPmsSettingsContactAdmin:
      "Algo salió mal al actualizar las configuraciones de PMS. Si continúa viendo este problema, póngase en contacto con el administrador de la plataforma.",
    noAccessUpdatePerformanceManagementSettings:
      "Lo sentimos, no tiene acceso para actualizar las configuraciones de gestión del rendimiento. Por favor, contacte a su administrador.",

    idleTimeSettingsUpdated:
      "Configuración de tiempo inactivo de monitoreo de productividad actualizada con éxito",
    idleTimeTechnicalDifficulties: "{technicalDifficulties}",
    idleTimeSomethingWentWrongFetching: "{somethingWentWrong}",
    idleTimeNoAccessUpdate:
      "Lo sentimos, no tiene derechos para actualizar la configuración de tiempo inactivo. Por favor, contacte al administrador del sistema.",
    idleTimeOrgSettingsUpdatedEmployeeError:
      "{orgSettingsUpdatedEmployeeError}",
    idleTimeErrorUpdatingOrgSettings: "{somethingWentWrong}",
    idleTimeErrorUpdatingEmpSettings: "{somethingWentWrong}",
    idleTimeErrorUpdatingSettings: "{somethingWentWrong}",
    fixedHoursMinimum: "Las horas fijas deben ser de al menos 1 hora",
    fixedHoursInvalidEmployee:
      "Corrija las horas fijas no válidas de los empleados antes de guardar",
    idleTimeMixedSettingsNote:
      "Tener configuraciones mixtas de tiempo de inactividad para los empleados causará inconsistencias en la representación de datos de productividad en informes y análisis. Por favor, asegúrese de este impacto antes de configurar la configuración de tiempo de inactividad a nivel de empleado.",

    /* ----- EmployeeMonitoring ----- */
    productivityMonitoring: "Monitoreo de Productividad",
    appsAndUrls: "Aplicaciones y URLs",
    off: "Apagado",
    idleTime: "Tiempo Ocioso",
    dailyInsightsNotification: "Notificación de Información Diaria",
    somethingWentWrongLoadingSettings:
      "Algo salió mal al cargar la configuración de monitoreo de productividad. Por favor, inténtelo después de un tiempo.",

    /* ----- DailyInsightsNotification ----- */
    dailyInsightsNotificationDescription:
      "Configure para compartir información diaria con individuos según su productividad",
    adminNotification: "Notificación de Administrador",
    adminNotificationDescription:
      "Configure para compartir información diaria con administradores según la productividad de la organización",
    managerNotification: "Notificación de Gerente",
    managerNotificationDescription:
      "Configure para compartir información diaria con gerentes según la productividad del equipo",
    inviteTeamMembersInsights:
      "Por favor, invite a los miembros de su equipo para configurar la notificación de información.",
    key: "Clave",
    accessDeniedMsgInsights:
      "Lo sentimos, no tiene derechos para actualizar. Por favor, contacte al administrador de RRHH.",

    /* ----- AppUrlCategoryModel ----- */
    apps: "Aplicaciones",
    urls: "URLs",
    category: "Categoría",
    customGroup: "Grupo Personalizado",
    customAlert: "Alerta Personalizada",
    toxicityIdentifier: "Identificador de Toxicidad",
    selectCustomGroup: "Seleccionar Grupo Personalizado",
    copyClassificationFrom: "Copiar Clasificación Desde",
    copyNow: "Copiar Ahora",
    all: "Todos",
    productive: "Productivo",
    unproductive: "Improductivo",
    uncategorized: "Sin Categorizar",
    applicationName: "Nombre de la Aplicación",
    wildcardConfiguration: "Configuración de Comodín",
    export: "Exportar",
    back: "Atrás",
    domainName: "Nombre de Dominio",
    addMore: "Agregar Más",
    classificationsCopiedSuccess: "¡Clasificaciones Copiadas con Éxito!",
    appsCategoryListUpdated:
      "Lista de categorías de aplicaciones actualizada con éxito.",
    urlsCategoryListUpdated:
      "Lista de categorías de URLs actualizada con éxito.",
    noAccessUpdateSettings:
      "Lo sentimos, no tiene derechos para actualizar la configuración de monitoreo de productividad. Por favor, contacte a su administrador.",
    domainWhitelistingUpdated: "Lista blanca de dominio {action} con éxito.",
    noAccessUpdateDomainWhitelisting:
      "Lo sentimos, no tiene derechos para actualizar la configuración de lista blanca de dominio. Por favor, contacte a su administrador.",
    domainAlreadyExists:
      "No se puede agregar/actualizar el dominio ya que ya existe",
    technicalDifficultiesDomainWhitelisting:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongDomainWhitelisting:
      "Algo salió mal con la configuración de lista blanca de dominio. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongValidatingDomainWhitelisting:
      "Algo salió mal al validar las entradas al actualizar la configuración de lista blanca de dominio. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongUpdatingDomainWhitelisting:
      "Algo salió mal al actualizar la configuración de lista blanca de dominio. Si continúa viendo este problema, contacte al administrador de la plataforma.",

    /* ----- AppUrlCategoryCard ----- */
    noAppsToCategorize: "No tiene ninguna aplicación para categorizar.",
    noUrlsToCategorize: "No tiene ninguna URL para categorizar.",

    /* ----- AppsAndUrlsTracker ----- */
    appsAndUrlsTracker: "Rastreador de Aplicaciones y URLs",
    appsAndUrlsTrackerDescription:
      "Controla el monitoreo de aplicaciones y sitios web para la organización",
    defaultCategory: "Categoría Predeterminada",
    classificationForGroup: "Clasificación para el Grupo",
    unableToFetchCustomGroup:
      "No se puede obtener el Grupo de Empleados Personalizado. Por favor, actualice e intente nuevamente.",
    classifyAppsAndUrlsForTeams:
      "Puede clasificar aplicaciones y URLs para equipos",
    createGroup: "Crear Grupo",
    group: "Grupo",
    trackAppsAndUrls: "Rastrear Aplicaciones y URLs",
    inviteTeamMembersToTrackActivities:
      "Por favor, invite a los miembros de su equipo para rastrear sus actividades.",
    appsAndUrlsSettingsUpdated:
      "Configuración de aplicaciones y URLs de monitoreo de productividad actualizada con éxito",

    /* ----- Admin and Member Management ----- */
    adminManagerInvitees: "Invitados Admin/Gerente",
    adminsManagersOnboardedSuccessfully:
      "Admins/Gerentes incorporados exitosamente",
    importTeamMembersErrorMessage:
      "Error al procesar la solicitud para importar los miembros del equipo",
    confirmDeleteInvite: "¿Está seguro de que desea eliminar esta invitación?",
    emailAddressAlreadyExists: "La dirección de correo electrónico ya existe",
    emailAddressUpdatedSuccessfully:
      "Dirección de correo electrónico actualizada exitosamente",
    invitedMemberDeletedSuccessfully: "Miembro invitado eliminado exitosamente",
    onboard: "Incorporar",
    onboardNewAdminMember: "Incorporar Nuevo Admin/Miembro",

    /* ----- Access Rights Messages ----- */
    noAccessRightsToSendNotificationToOfflineEmployees:
      "Lo sentimos, no tiene derechos de acceso para enviar notificaciones a empleados desconectados. Por favor, contacte a su administrador.",
    noAccessRightsToViewActivitySummaries:
      "Lo sentimos, no tiene derechos de acceso para ver resúmenes de actividad. Por favor, contacte a su administrador.",
    noAccessRightsToViewTeamActivityDetails:
      "Lo sentimos, no tiene derechos de acceso para ver detalles de actividad del equipo. Por favor, contacte a su administrador.",
    noAccessToDeleteInvitedMembers:
      "Lo sentimos, no tiene acceso para eliminar miembros invitados. Por favor, contacte a su administrador.",
    noAccessToInviteAdminsManagers:
      "Lo sentimos, no tiene acceso para invitar admins/gerentes. Por favor, contacte a su administrador.",
    noAccessToResendInvitations:
      "Lo sentimos, no tiene acceso para reenviar invitaciones. Por favor, contacte a su administrador.",
    noAccessToUpdateEmailAddress:
      "Lo sentimos, no tiene acceso para actualizar direcciones de correo electrónico. Por favor, contacte a su administrador.",
    noAccessToViewAdminsManagers:
      "Lo sentimos, no tiene acceso para ver admins/gerentes. Por favor, contacte a su administrador.",
    noAccessToViewInvitedAdmins:
      "Lo sentimos, no tiene acceso para ver admins invitados. Por favor, contacte a su administrador.",
    noAccessToViewTeamMembersList:
      "Lo sentimos, no tiene acceso para ver la lista de miembros del equipo. Por favor, contacte a su administrador.",
    noAccessUpdateDLP:
      "Lo sentimos, no tiene acceso para actualizar la configuración de DLP. Por favor, contacte a su administrador.",

    /* ----- Error Messages ----- */
    somethingWentWrongFetchingDLP:
      "Algo salió mal al obtener la configuración de DLP. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongUpdatingDLP:
      "Algo salió mal al actualizar la configuración de DLP. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongWhileFetchingAdminsManagers:
      "Algo salió mal al obtener admins/gerentes. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongWhileFetchingInvitedAdmins:
      "Algo salió mal al obtener admins invitados. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongWhileFetchingTeamActivityDetails:
      "Algo salió mal al obtener detalles de actividad del equipo. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongWhileFetchingTeamActivityDetailsContactAdmin:
      "Algo salió mal al obtener detalles de actividad del equipo. Si continúa viendo este problema, contacte al administrador de la plataforma.",
    somethingWentWrongWhileFetchingTeamMembers:
      "Algo salió mal al obtener miembros del equipo. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongWhileInvitingAdminsManagers:
      "Algo salió mal al invitar admins/gerentes. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongWhileNotifyingOfflineEmployees:
      "Algo salió mal al notificar a empleados desconectados. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongWhileNotifyingOfflineEmployeesContactAdmin:
      "Algo salió mal al notificar a empleados desconectados. Si continúa viendo este problema, contacte al administrador de la plataforma.",
    somethingWentWrongWhileResendingInvitation:
      "Algo salió mal al reenviar la invitación. Por favor, inténtelo después de un tiempo.",
    somethingWentWrongWhileUpdatingEmailAddress:
      "Algo salió mal al actualizar la dirección de correo electrónico. Por favor, inténtelo después de un tiempo.",

    /* ----- Notifications and Success Messages ----- */
    notificationSentSuccessfullyToOfflineEmployees:
      "Notificación enviada exitosamente a empleados desconectados",

    /* ----- Work Schedule ----- */
    addWorkScheduleNoUpdateAccess:
      "Lo sentimos, no tiene acceso para agregar horarios de trabajo. Por favor, contacte a su administrador.",

    /* ----- Reports ----- */
    customReportHeaders: "Encabezados de Informes Personalizados",
    dailyInsightsNotificationReports:
      "Informes de Notificación de Información Diaria",
    dataIntegration: "Integración de Datos",
    headerFooterTemplates: "Plantillas de Encabezado y Pie de Página",
    headerTemplate: "Plantilla de Encabezado",
    footerTemplate: "Plantilla de Pie de Página",
    selectTemplate: "Seleccionar Plantilla",
    notConfigured: "No configurado",
    successHeaderFooterUpdate:
      "Plantilla de encabezado/pie de página actualizada con éxito",
    errorUpdatingHeaderFooter:
      "Algo salió mal al actualizar la plantilla. Por favor, inténtelo de nuevo.",
    timeActivityReport: "Informe de Actividad de Tiempo",
    timeActivityReportContent:
      "Muestra el tiempo dedicado a diferentes actividades",
    attendanceReport: "Informe de Asistencia",
    attendanceReportContent: "Muestra detalles de asistencia",
    appsReport: "Informe de Aplicaciones",
    appsReportContent: "Muestra detalles de uso de aplicaciones",
    appsTitleReport: "Informe de Títulos de Aplicaciones",
    appsTitleReportContent: "Muestra detalles de títulos de aplicaciones",
    urlsReport: "Informe de URLs",
    urlsReportContent: "Muestra detalles de uso de URLs",
    productiveAppsReport: "Informe de Aplicaciones Productivas",
    productiveAppsReportContent:
      "Muestra detalles de uso de aplicaciones productivas",
    productiveUrlsReport: "Informe de URLs Productivas",
    productiveUrlsReportContent: "Muestra detalles de uso de URLs productivas",
    consolidatedAppsUrlsReport: "Informe Consolidado de Aplicaciones y URLs",
    consolidatedAppsUrlsReportContent:
      "Muestra detalles consolidados de uso de aplicaciones y URLs",
    efficiencyReport: "Informe de Eficiencia",
    efficiencyReportContent: "Muestra métricas de eficiencia",
    lowActivityReport: "Informe de Baja Actividad",
    lowActivityReportContent: "Muestra períodos de baja actividad",
    productivitySummaryReport: "Informe Resumen de Productividad",
    productivitySummaryReportContent: "Muestra resumen de productividad",
    productiveUnproductiveSummaryReport:
      "Informe Resumen Productivo/Improductivo",
    productiveUnproductiveSummaryReportContent:
      "Muestra resumen de actividad productiva e improductiva",
    productiveAppsMetric: "Métrica de Aplicaciones Productivas",
    productiveAppsMetricContent: "Muestra métricas de aplicaciones productivas",
    productiveUrlsMetric: "Métrica de URLs Productivas",
    productiveUrlsMetricContent: "Muestra métricas de URLs productivas",
    unproductiveAppsMetrics: "Métricas de Aplicaciones Improductivas",
    unproductiveAppsMetricsContent:
      "Muestra métricas de aplicaciones improductivas",
    unproductiveUrlsMetric: "Métrica de URLs Improductivas",
    unproductiveUrlsMetricContent: "Muestra métricas de URLs improductivas",
    monthlySummaryReport: "Informe Resumen Mensual",
    monthlySummaryReportContent: "Muestra resumen de actividad mensual",
    weeklySummaryReport: "Informe Resumen Semanal",
    weeklySummaryReportContent: "Muestra resumen de actividad semanal",
    fileAndWebFileEventSummaryReport:
      "Informe Resumen de Eventos de Archivos y Archivos Web",
    fileAndWebFileEventSummaryReportContent:
      "Muestra resumen de eventos de archivos y archivos web",
    fileEventReport: "Informe de Eventos de Archivos",
    fileEventReportContent: "Muestra detalles de eventos de archivos",
    webFileEventReport: "Informe de Eventos de Archivos Web",
    locationIntelligenceReport: "Informe de Inteligencia de Ubicación",
    locationIntelligenceReportContent:
      "Muestra detalles de inteligencia de ubicación",
    locationIntelligenceMonthlySummaryReport:
      "Informe Resumen Mensual de Inteligencia de Ubicación",
    locationIntelligenceMonthlySummaryReportContent:
      "Muestra resumen de inteligencia de ubicación mensual",
    webFileEventReportContent: "Muestra detalles de eventos de archivos web",
    assetReport: "Informe de Activos",
    assetReportContent: "Muestra detalles de activos",
    errorTechnicalDifficulties: "{technicalDifficulties}",
    errorProcessingReportHeaders: "{somethingWentWrong}",
    errorNoReportHeadersConfig:
      "Los datos de configuración personalizada no existen. Por favor, contacte al administrador del sistema.",
    errorRetrievingReports: "{somethingWentWrong}",
    errorRetrievingReportsGeneric: "{somethingWentWrong}",
    errorTechnicalIssue: "{technicalDifficulties}",
    errorNoUpdateRights:
      "Lo sentimos, no tiene derechos para actualizar los encabezados de informes. Por favor, contacte al administrador de RRHH.",
    errorUpdatingInsightsSettings: "{somethingWentWrong}",
    errorUpdatingInsightsSettingsGeneric: "{somethingWentWrong}",
    errorNoDefaultHeaders: "No default headers found for this report.",
    successInsightsNotificationUpdate:
      "Configuración de notificación de información actualizada con éxito",
    successReportHeadersUpdate:
      "Configuración de encabezados de informes actualizada con éxito",
    errorNoFormChanges: "{formNoChanges}",
    errorTechnicalDifficultiesHeaders: "{technicalDifficulties}",
    errorNoHeaderUpdateRights:
      "Lo sentimos, no tiene derechos para actualizar los encabezados de informes. Por favor, contacte al administrador de RRHH.",
    errorUpdatingReportHeaders: "{somethingWentWrong}",
    errorUpdatingReportHeadersGeneric: "{somethingWentWrong}",

    /* ----- Error Messages ----- */
    somethingWentWrong:
      "Algo salió mal. Si continúa viendo este problema, hable con su administrador de plataforma.",
    noAccessRights:
      "Lo sentimos, no tiene derechos para {action}. Por favor, contacte al administrador de {admin}.",
    settingsUpdated: "Configuración de {setting} actualizada con éxito",
    unableToFetch:
      "No se puede obtener {item}. Por favor, actualice e intente nuevamente.",
  },
};
